// src/components/TokenLogin.jsx
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../firebase";

export default function TokenLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      signInWithCustomToken(auth, token)
        .then(() => {
          // Login OK, redirige a la página principal o dashboard
          navigate("/post-login");
        })
        .catch((error) => {
          console.error("Error en signInWithCustomToken:", error);
          // Aquí puedes manejar errores, mostrar mensaje, etc.
        });
    } else {
      console.log("No se encontró token en la URL");
    }
  }, [searchParams, navigate]);

  return (
    <div>
      <h2>Iniciando sesión...</h2>
      {/* Aquí puedes agregar un spinner o mensaje */}
    </div>
  );
}
